<div class="title">
    <div mat-dialog-title>Warning</div>
    <button (click)="onCancel()" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
    </button>
</div>

<mat-dialog-content>
    <p>
        <strong>
            This meeting will end in <span class=""><span class="time-chip">{{ countdown }}</span></span>
        </strong>
    </p>

    <p>
        There is a scheduled meeting in {{ initalMinutes }} minute{{ minutes === 1 ? '' : 's' }}.
        This meeting will automatically close when the countdown reaches zero.
    </p>
</mat-dialog-content>

<mat-dialog-actions align="end" class="action-btn">
    <button class="change-room-btn" (click)="onCancel()">
        Exit now
    </button>

    <button class="create-btn" (click)="onConfirm()">
        Got it
    </button>
</mat-dialog-actions>
